import { useState } from 'react';

const VALID = /^[\w\s\u0600-\u06FF\-'\.]+$/;

const CHARACTER_TYPES = [
  { key: 'robot',      ar: 'روبوت',     en: 'Robot' },
  { key: 'adventurer', ar: 'مغامر',     en: 'Adventurer' },
  { key: 'scientist',  ar: 'عالم',      en: 'Scientist' },
  { key: 'superhero',  ar: 'بطل خارق', en: 'Superhero' },
  { key: 'artist',     ar: 'فنان',      en: 'Artist' },
  { key: 'anime',      ar: 'أنمى',      en: 'Anime' },
  { key: 'cartoon',    ar: 'كارتون',    en: 'Cartoon' },
  { key: 'animation',  ar: 'أنيميشن',  en: 'Animation' },
];

const GENDERS = [
  { key: 'boy',  ar: 'ولد', en: 'Boy' },
  { key: 'girl', ar: 'بنت', en: 'Girl' },
];

const MOODS = [
  { key: 'playful',    ar: 'مرح',   en: 'Playful' },
  { key: 'serious',    ar: 'جاد',   en: 'Serious' },
  { key: 'mysterious', ar: 'غامض',  en: 'Mysterious' },
  { key: 'friendly',   ar: 'ودود',  en: 'Friendly' },
  { key: 'brave',      ar: 'شجاع',  en: 'Brave' },
];

const STEP_NUM = {
  ar: ['١', '٢', '٣', '٤'],
  en: ['1', '2', '3', '4'],
};

const T = {
  ar: {
    step1Title: 'اختر نوع شخصيتك',
    step2Title: 'الجنس',
    step3Title: 'مزاج شخصيتك',
    step4Title: 'اكتب اسم شخصيتك',
    step4Ph:    'مثال: سونيك، ماريو، روبو...',
    step4Note:  'سيتم رسم شخصيتك بناءً على اختياراتك واسمها',
    stepOf:     'من ٤',
    next:       'التالي ←',
    back:       '→ رجوع',
    submit:     'ابدأ رحلتك! 🚀',
    errEmpty:   'هذا الحقل مطلوب',
    errSpecial: 'يحتوي على رموز غير مسموح بها',
    errMax:     'الاسم طويل جداً',
  },
  en: {
    step1Title: 'Choose your character type',
    step2Title: 'Gender',
    step3Title: 'Character mood',
    step4Title: 'Write your character name',
    step4Ph:    'e.g. Sonic, Mario, Robo...',
    step4Note:  'Your character will be drawn based on your choices',
    stepOf:     'of 4',
    next:       'Next →',
    back:       '← Back',
    submit:     'Start your journey! 🚀',
    errEmpty:   'This field is required',
    errSpecial: 'Contains invalid characters',
    errMax:     'Name is too long',
  },
};

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=Nunito:wght@400;500;600;700&display=swap');

  .aw-step-indicator {
    text-align: center;
    font-family: 'Sora', sans-serif;
    font-size: .82rem; font-weight: 700;
    color: #6B7280;
    margin-bottom: 18px;
    letter-spacing: .03em;
  }
  .aw-step-indicator span { color: #059669; }

  .aw-title {
    font-family: 'Sora', sans-serif;
    font-size: 1rem; font-weight: 800;
    color: #064E3B; text-align: center;
    margin-bottom: 20px;
  }

  .aw-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-bottom: 24px;
  }
  .aw-grid-5 { grid-template-columns: repeat(3, 1fr); }

  .aw-card {
    padding: 14px 10px;
    border: 2.5px solid #E5E7EB;
    border-radius: 16px;
    background: white;
    cursor: pointer;
    text-align: center;
    font-family: 'Sora', sans-serif;
    font-size: .9rem; font-weight: 700;
    color: #1F2937;
    transition: border-color .15s, background .15s, transform .08s, box-shadow .15s;
    box-shadow: 0 2px 0 #E5E7EB;
    user-select: none;
  }
  .aw-card:hover {
    border-color: #10B981;
    background: #F0FDF4;
    transform: translateY(-2px);
    box-shadow: 0 4px 0 #A7F3D0;
  }
  .aw-card.selected {
    border-color: #059669;
    background: #D1FAE5;
    color: #064E3B;
    box-shadow: 0 3px 0 #6EE7B7;
    transform: translateY(-1px);
  }
  .aw-card.gender { padding: 20px 10px; font-size: 1.05rem; }

  .aw-field { margin-bottom: 16px; }
  .aw-input {
    width: 100%; padding: 13px 16px;
    font-family: 'Nunito', sans-serif;
    font-size: 1rem; font-weight: 600;
    color: #1F2937; background: white;
    border: 2px solid #E5E7EB;
    border-radius: 18px; outline: none;
    transition: border-color .15s, box-shadow .15s;
    direction: inherit;
    box-shadow: 0 3px 0 #E5E7EB;
  }
  .aw-input:focus {
    border-color: #059669;
    box-shadow: 0 3px 0 rgba(5,150,105,.2), 0 0 0 4px rgba(5,150,105,.1);
  }
  .aw-input.err {
    border-color: #EF4444;
    box-shadow: 0 3px 0 rgba(239,68,68,.15);
  }
  .aw-input::placeholder { color: #C4C4C4; font-weight: 400; }
  .aw-field-footer {
    display: flex; justify-content: space-between;
    align-items: center; margin-top: 5px; min-height: 18px;
  }
  .aw-err-txt { font-size: .78rem; color: #EF4444; font-weight: 700; }
  .aw-counter { font-size: .75rem; color: #6B7280; }
  .aw-counter.warn { color: #D97706; font-weight: 700; }
  .aw-note {
    font-size: .78rem; color: #6B7280;
    text-align: center; margin-top: 8px; line-height: 1.5;
  }

  .aw-nav { display: flex; gap: 10px; margin-top: 4px; }
  .aw-nav-back { flex: 0 0 auto; }
  .aw-nav-next { flex: 1; }

  .aw-btn {
    width: 100%; padding: 15px;
    font-family: 'Sora', sans-serif;
    font-size: 1rem; font-weight: 700;
    border: none; border-radius: 20px;
    cursor: pointer; transition: transform .08s, box-shadow .08s;
    display: flex; align-items: center; justify-content: center; gap: 8px;
  }
  .aw-btn-primary {
    background: #D1FAE5; color: #065F46; font-weight: 900;
    border: 2px solid #6EE7B7;
    box-shadow: 0 5px 0 #6EE7B7, 0 8px 20px rgba(5,150,105,.15);
  }
  .aw-btn-primary:hover:not(:disabled) {
    transform: translateY(-3px);
    box-shadow: 0 5px 0 #6EE7B7, 0 14px 26px rgba(5,150,105,.2);
  }
  .aw-btn-primary:active:not(:disabled) { transform: translateY(4px); box-shadow: 0 1px 0 #6EE7B7; }
  .aw-btn-primary:disabled {
    background: #F3F4F6; color: #9CA3AF;
    border: 2px solid #D1D5DB;
    box-shadow: 0 3px 0 #D1D5DB; cursor: not-allowed;
  }
  .aw-btn-back {
    background: white; color: #6B7280;
    border: 2px solid #E5E7EB;
    box-shadow: 0 3px 0 #E5E7EB;
    padding: 15px 18px; width: auto;
  }
  .aw-btn-back:hover {
    border-color: #D1D5DB; color: #1F2937;
    transform: translateY(-2px);
  }

  @media (max-width: 480px) {
    .aw-grid-5 { grid-template-columns: repeat(2, 1fr); }
  }
`;

export default function AvatarWizard({ lang = 'ar', onSubmit, onCancel }) {
  const [wizardStep,    setWizardStep]    = useState(1);
  const [characterType, setCharacterType] = useState('');
  const [gender,        setGender]        = useState('');
  const [mood,          setMood]          = useState('');
  const [characterName, setCharacterName] = useState('');
  const [nameError,     setNameError]     = useState('');

  const t = T[lang] || T.ar;

  const validateName = (value) => {
    if (!value.trim()) return t.errEmpty;
    if (!VALID.test(value)) return t.errSpecial;
    if (value.length > 200) return t.errMax;
    return '';
  };

  const nextStep = () => setWizardStep(s => s + 1);
  const prevStep = () => {
    if (wizardStep === 1) { onCancel?.(); return; }
    setWizardStep(s => s - 1);
  };

  const stepCanAdvance = () => {
    if (wizardStep === 1) return !!characterType;
    if (wizardStep === 2) return !!gender;
    if (wizardStep === 3) return !!mood;
    if (wizardStep === 4) return !validateName(characterName);
    return false;
  };

  const handleSubmit = () => {
    const err = validateName(characterName);
    setNameError(err);
    if (err) return;
    onSubmit({ characterType, gender, mood, characterName });
  };

  return (
    <>
      <style>{CSS}</style>

      <div className="aw-step-indicator">
        <span>{(STEP_NUM[lang] || STEP_NUM.ar)[wizardStep - 1]}</span> {t.stepOf}
      </div>

      {wizardStep === 1 && (
        <>
          <div className="aw-title">{t.step1Title}</div>
          <div className="aw-grid">
            {CHARACTER_TYPES.map(opt => (
              <div
                key={opt.key}
                className={`aw-card${characterType === opt.key ? ' selected' : ''}`}
                onClick={() => setCharacterType(opt.key)}
              >
                {opt[lang] || opt.ar}
              </div>
            ))}
          </div>
          <button
            className="aw-btn aw-btn-primary"
            onClick={nextStep}
            disabled={!characterType}
          >
            {t.next}
          </button>
        </>
      )}

      {wizardStep === 2 && (
        <>
          <div className="aw-title">{t.step2Title}</div>
          <div className="aw-grid" style={{ marginBottom: 24 }}>
            {GENDERS.map(opt => (
              <div
                key={opt.key}
                className={`aw-card gender${gender === opt.key ? ' selected' : ''}`}
                onClick={() => setGender(opt.key)}
              >
                {opt[lang] || opt.ar}
              </div>
            ))}
          </div>
          <div className="aw-nav">
            <button className="aw-btn aw-btn-back aw-nav-back" onClick={prevStep}>{t.back}</button>
            <button
              className="aw-btn aw-btn-primary aw-nav-next"
              onClick={nextStep}
              disabled={!gender}
            >
              {t.next}
            </button>
          </div>
        </>
      )}

      {wizardStep === 3 && (
        <>
          <div className="aw-title">{t.step3Title}</div>
          <div className="aw-grid aw-grid-5" style={{ marginBottom: 24 }}>
            {MOODS.map(opt => (
              <div
                key={opt.key}
                className={`aw-card${mood === opt.key ? ' selected' : ''}`}
                onClick={() => setMood(opt.key)}
              >
                {opt[lang] || opt.ar}
              </div>
            ))}
          </div>
          <div className="aw-nav">
            <button className="aw-btn aw-btn-back aw-nav-back" onClick={prevStep}>{t.back}</button>
            <button
              className="aw-btn aw-btn-primary aw-nav-next"
              onClick={nextStep}
              disabled={!mood}
            >
              {t.next}
            </button>
          </div>
        </>
      )}

      {wizardStep === 4 && (
        <>
          <div className="aw-title">{t.step4Title}</div>
          <div className="aw-field">
            <input
              className={`aw-input${nameError ? ' err' : ''}`}
              type="text"
              placeholder={t.step4Ph}
              value={characterName}
              maxLength={200}
              onBlur={() => setNameError(validateName(characterName))}
              onChange={e => {
                setCharacterName(e.target.value);
                if (nameError) setNameError(validateName(e.target.value));
              }}
            />
            <div className="aw-field-footer">
              {nameError ? <span className="aw-err-txt">{nameError}</span> : <span />}
              <span className={`aw-counter${characterName.length > 160 ? ' warn' : ''}`}>
                {characterName.length}/200
              </span>
            </div>
            <p className="aw-note">{t.step4Note}</p>
          </div>
          <div className="aw-nav">
            <button className="aw-btn aw-btn-back aw-nav-back" onClick={prevStep}>{t.back}</button>
            <button
              className="aw-btn aw-btn-primary aw-nav-next"
              onClick={handleSubmit}
              disabled={!stepCanAdvance()}
            >
              {t.submit}
            </button>
          </div>
        </>
      )}
    </>
  );
}
